/**
 * Die mittlere Stufe der Breadcrumb: die Gruppe der Seitenleiste, in der die
 * aktive Seite steht (Lebensbereich › **Gruppe** › Seite).
 */

/**
 * Die erste Gruppe jeder Seitenleiste. „Ruhend" und „Geschafft" fehlten hier
 * und fielen in den Rückfall „Projekte" (24.09.2026).
 */
const FIRST_GROUP = ['today', 'week', 'upcoming', 'tasks', 'dormant', 'done']

/**
 * Map an active-tab path to its sidebar section i18n key.
 *
 * **Kurz notiert hat keine Gruppe** (#273): Dort steht in Ruhe nur der Lebensbereich; der Name
 * kommt als Titel-Stufe, sobald die Überschrift weggerollt ist — wie auf den anderen Seiten.
 * Bis 06.10.2026 stand „Kurz notiert“ hier als Gruppe und damit immer da.
 */
export function getSectionTitle(path: string | undefined, t: (key: string) => string): string {
  if (!path) return ''

  // Quick notes (legacy shared route — keep for backwards compatibility)
  if (path === '/home/quick-notes') return ''

  // Personal space
  if (path.startsWith('/home/personal/')) {
    const segment = path.split('/')[3] // today | upcoming | tasks | habits | quick-notes | ...
    if (segment === 'quick-notes') return ''
    if (FIRST_GROUP.includes(segment)) return t('sidebar.quickOverview')
    if (['habits', 'recurring', 'goals'].includes(segment)) return t('sidebar.personalSection')
    return t('sidebar.projects')
  }

  // Work space
  if (path.startsWith('/home/work/')) {
    const segment = path.split('/')[3]
    if (segment === 'quick-notes') return ''
    if (FIRST_GROUP.includes(segment)) return t('sidebar.workToday')
    if (['habits', 'recurring', 'goals'].includes(segment)) return t('sidebar.workSection')
    return t('sidebar.projects')
  }

  // Home space
  if (path.startsWith('/home/home/')) {
    const segment = path.split('/')[3]
    if (segment === 'quick-notes') return ''
    if (FIRST_GROUP.includes(segment)) return t('sidebar.homeSection')
    if (['habits', 'recurring', 'goals'].includes(segment)) return t('sidebar.homeSpaceSection')
    return t('sidebar.categories')
  }

  return ''
}
